import type { ComponentProps } from 'react';
import { memo } from 'react';

import { cn } from '@/shared/utils/cn';

import { TIER_REQUIREMENTS } from '../constants';
import { ProfileNonToxicTierItem } from './nonToxicTierItem';

export interface ProfileNonToxicTierProps extends ComponentProps<'div'> {
  tier: number;
}

export const ProfileNonToxicTier = memo(function ProfileNonToxicTier({
  tier,
  className,
  ...rest
}: ProfileNonToxicTierProps) {
  return (
    <div className={cn('relative flex flex-col gap-2', className)} {...rest}>
      {/* Vertical connector line behind badges */}
      <div className="bg-cold-800 absolute top-5 bottom-5 left-[22px] w-1 rounded-full" />

      {TIER_REQUIREMENTS.map(config => {
        const isActive = config.tier <= tier;
        const isCurrentTier = config.tier === tier;

        return (
          <ProfileNonToxicTierItem
            key={config.label}
            label={config.label}
            tier={config.tier}
            isActive={isActive}
            isCurrentTier={isCurrentTier}
            requirement={config.requirement}
            altRequirement={
              'altRequirement' in config ? config.altRequirement : undefined
            }
          />
        );
      })}
    </div>
  );
});
